import React from 'react';
import { motion } from 'framer-motion';
import { Shield } from 'lucide-react';
export function Guarantee() {
  const fadeInUp = {
    initial: {
      opacity: 0,
      y: 20
    },
    whileInView: {
      opacity: 1,
      y: 0
    },
    viewport: {
      once: true
    },
    transition: {
      duration: 0.5
    }
  };
  return <section className="py-16 px-4" data-id="element-70">
      <motion.div {...fadeInUp} className="max-w-3xl mx-auto" data-id="element-71">
        <div className="bg-gradient-to-br from-primary/10 to-primary/5 rounded-2xl p-8 md:p-12 text-center border-2 border-primary/20" data-id="element-72">
          <div className="inline-block bg-primary/10 p-4 rounded-full mb-6" data-id="element-73">
            <Shield className="w-16 h-16 text-primary" data-id="element-74" />
          </div>

          <h2 className="font-playfair text-3xl md:text-4xl font-bold text-dark mb-6" data-id="element-75">
            Probalo sin riesgo durante 7 días
          </h2>

          <div className="text-lg text-dark/80 leading-relaxed space-y-4" data-id="element-76">
            <p data-id="element-77">
              Estamos convencidos de que este material puede ayudarte a comer
              mejor de una forma más práctica, rica y realista.
            </p>

            <p data-id="element-78">
              Por eso, si dentro de los primeros 7 días sentís que no era para
              vos, podés pedir la devolución total de tu dinero.
            </p>

            <div className="pt-4 space-y-2 font-semibold text-dark" data-id="element-79">
              <p data-id="element-80">Sin vueltas.</p>
              <p data-id="element-81">Sin complicaciones.</p>
              <p data-id="element-82">Sin riesgo para vos.</p>
            </div>
          </div>
        </div>
      </motion.div>
    </section>;
}